import React, { Component } from 'react';
import { withRouter } from 'react-router';
import './App.css';
import AccountMenu from './AccountMenu';
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import { Button, Grid, Popup, List, Menu } from 'semantic-ui-react'

import {InstantSearch, SearchBox, Hits} from 'react-instantsearch/dom';

import { BASE_CDN_URL } from './helper/constants'


class App extends Component {
  static propTypes = { 
    // history: React.PropTypes.object.isRequired,      
  } 
  state = { 
    modalOpen: false, 
    activeItem: 'gamepad',
    itemname: '',
    organisationid: '',
    userid: '',
    boardid: '',
    suppliers: null,
    colors: null
  } 
  

  handleItemClick = (e, { name }) => this.setState({ activeItem: name })
  handleOpen = () => this.setState({ modalOpen: true })
  handleClose = () => this.setState({ modalOpen: false })

  Hit = ({hit}) => {
    return (
    <div className="hit" onClick={()=>{
      this.props.history.push('/'+hit.boardid)
    }}>
      <div className="hit-image">
        <img alt={hit.title} src={BASE_CDN_URL+ '/' + hit.boardid + '/public/screen.jpg'}/>
      </div>
      <div className="hit-content">
        <h3>{hit.title}</h3>
        <div className="hit-color">{hit.colorList}</div>
        <div className="hit-category">{hit.categoryList}</div>
      </div>
    </div>
    );
  }



  render() {

    const { activeItem } = this.state

    

    // if (this.props.UserQuery.loading) {      
    //   return (
    //       <div className="App">
    //           Loading...
    //       </div>
    //   )
    // }    
   


    return (
      <div className="App">

        
        <header className="App-header">
          <Grid doubling>
            <Grid.Column computer={2} tablet={3} className="logo--container" floated='left' only='computer tablet'>
              <a href="/">
                <img src={require('./img/Brikl-Discovery-logo.svg')} alt="BrikL Logo" className="logo--brikl"/>
              </a>
          </Grid.Column>
            <Grid.Column computer={11} tablet={10} mobile={16} className="search--container">
              <InstantSearch
                appId="CU4R6NNL4A"
                apiKey="73189e51bc5366435eb3cac4e991fb59"
                indexName={
                  window.location.hostname === 'discovery.brikl.io' ?
                  'production-brikl-discovery' :
                  window.location.hostname === 'staging.discovery.brikl.io' ?
                  'staging-brikl-discovery'
                  : 'local-brikl-discovery'
                }
                onSearchStateChange={(e)=>this.setState({searchstate:e})}
              >                 
                <SearchBox />
                {
                  this.state.searchstate &&
                  this.state.searchstate.query !== ''
                  ?
                  <Grid>
                    <Grid.Column computer={16} className="search--menu">
                  <Hits hitComponent={this.Hit}/>
                  </Grid.Column>
                  </Grid>
                  :null
                }  
              </InstantSearch>          
            </Grid.Column>
            <Grid.Column computer={3} tablet={3} floated="right" only='computer tablet' className="menu--container">

              <Popup
                trigger={<Button circular icon="content icon" className="home-menu" floated='right'/>}
                position='bottom right'
                on='click'
                >
                <List>
                  <List.Item><a href="/">Home Discovery</a></List.Item>
                  <List.Item><a rel="noopener noreferrer" target="_blank" href="https://www.brikl.io/design">BrikL Design</a></List.Item>
                  <List.Item><a rel="noopener noreferrer" target="_blank" href="https://www.brikl.io/commerce">BrikL Commerce</a></List.Item>
                  <List.Item><a rel="noopener noreferrer" target="_blank" href="https://www.brikl.io/terms">Terms & Privacy</a></List.Item>
                  <List.Item><a rel="noopener noreferrer" target="_blank" href="https://www.brikl.io/about">About</a></List.Item>
                  <List.Item><a rel="noopener noreferrer" target="_blank" href="https://medium.com/brikl">Blog</a></List.Item>
                </List>
              </Popup>

              <Popup
                className=""
                trigger={<Button circular icon="options" className="filter-menu" floated='left'/>}
                position='bottom right'
                on='click'
                >
                <List>
                  <List.Item><a href="/">Home feed</a></List.Item>
                  {/* <List.Item><a href="">Popular</a></List.Item> */}
                  <List.Item><a href="/?category=men">Men</a></List.Item>
                  <List.Item><a href="/?category=women">Women</a></List.Item>
                  <List.Item><a href="/?category=babies">Babies</a>s</List.Item>
                  <List.Item><a href="/?category=boy">Boys</a></List.Item>
                  <List.Item><a href="/?category=girl">Girls</a></List.Item>
                  <List.Item><a href="/?color=red">Red</a></List.Item>
                  <List.Item><a href="/?color=orange">Orange</a></List.Item>
                  <List.Item><a href="/?color=yellow">Yellow</a></List.Item>
                  <List.Item><a href="/?color=green">Green</a></List.Item>
                  <List.Item><a href="/?color=blue">Blue</a></List.Item>
                  <List.Item><a href="/?color=indigo">Indigo</a></List.Item>
                  <List.Item><a href="/?color=violet">Voilet</a></List.Item>
                </List>
              </Popup>

              <Button circular className="account--menu">
                <AccountMenu />                
              </Button>

            </Grid.Column>

          </Grid>
        </header>  

        {this.props.children}

        <footer className="App-footer">
          <Grid className="footer--container">
            <Grid.Column width="16" only="mobile">
              <Menu fluid widths="3" borderless>
                <Menu.Item
                  name='home'
                  active={activeItem === 'home'}
                  onClick={this.handleItemClick}
                >
                   <a href="/"><img src={require('./img/BrikL-Logo.svg')} alt="BrikL Logo" className="logo--brikl"/></a>
                </Menu.Item>

               
                <Popup
                hideOnScroll
                trigger={ 
                  <Menu.Item
                  icon='options'
                  active={activeItem === 'filters'}
                  onClick={this.handleItemClick}
                  />}
                position='top center'
                on='click'
                >
                  <List>            
                    <List.Item><a href="/">Home feed</a></List.Item>
                    {/* <List.Item><a href="">Popular</a></List.Item> */}
                    <List.Item><a href="/?category=men">Men</a></List.Item>
                    <List.Item><a href="/?category=women">Women</a></List.Item>
                    <List.Item><a href="/?category=babies">Babies</a>s</List.Item>
                    <List.Item><a href="/?category=boy">Boys</a></List.Item>
                    <List.Item><a href="/?category=girl">Girls</a></List.Item>
                    <List.Item><a href="/?color=red">Red</a></List.Item>
                    <List.Item><a href="/?color=orange">Orange</a></List.Item>
                    <List.Item><a href="/?color=yellow">Yellow</a></List.Item>
                    <List.Item><a href="/?color=green">Green</a></List.Item>
                    <List.Item><a href="/?color=blue">Blue</a></List.Item>
                    <List.Item><a href="/?color=indigo">Indigo</a></List.Item>
                    <List.Item><a href="/?color=violet">Voilet</a></List.Item>
                  </List>
                </Popup>



                <Popup
                hideOnScroll
                trigger={<Menu.Item
                  icon='content'
                  active={activeItem === 'menu'}
                  onClick={this.handleItemClick}
                />}
                position='top right'
                on='click'
                >
                  <List>
                    <List.Item><a href="">Home Discovery</a></List.Item>
                    <List.Item><a href="https://www.brikl.io/design">BrikL Design</a></List.Item>
                    <List.Item><a href="https://www.brikl.io/commerce">BrikL Commerce</a></List.Item>
                    <List.Item><a href="https://www.brikl.io/terms">Terms & Privacy</a></List.Item>
                    <List.Item><a href="https://www.brikl.io/about">About</a></List.Item>
                    <List.Item><a href="https://medium.com/brikl">Blog</a></List.Item>
                  </List>
                </Popup>

              </Menu>
              </Grid.Column>
            </Grid>
        </footer>

      </div>
    );
  }
}

const user = gql`query user{
  user{
    id,
    username      
  }  
}`




const AppWithData = compose(
 graphql(
   user, {
     name: 'UserQuery',
     options: {
       operation: 'query',      
       fetchPolicy : 'network-only'
     }
   }
 ),   
 )(App)
 
 export default withRouter(AppWithData)



// WEBPACK FOOTER //
// ./src/App.js